import { products } from '@/mocks/products';
import QuantityStepper from './QuantityStepper';

type Product = (typeof products)[number];
type Props = { product: Product; qty: number; onQty: (n: number) => void; onRequest: () => void };

const fmt = (n: number) => `$${n.toFixed(2)}`;

export default function ProductInfo({ product, qty, onQty, onRequest }: Props) {
  return (
    <>
      <section className="bg-[#F8F6F2] border-b border-[rgba(23,21,21,0.1)]">
        <div className="fold-shell py-8 md:py-10 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="min-w-0">
            <p className="fold-label text-[#8A8580]">{product.category}</p>
            <h1 className="mt-3 text-4xl md:text-[64px] leading-[1] tracking-[-0.02em]">{product.name}</h1>
          </div>
          <div className="w-full lg:w-[380px] flex flex-col gap-3">
            <div className="flex items-center justify-between">
              <QuantityStepper value={qty} onChange={onQty} label={`${product.name} quantity`} />
              <span className="text-sm text-[#55504b] tabular-nums">{fmt(product.price)} each</span>
            </div>
            <button type="button" onClick={onRequest} className="group w-full whitespace-nowrap cursor-pointer bg-[#171515] text-[#F5F1EB] px-5 py-4 text-sm flex items-center justify-between gap-6 hover:bg-[#2b2827] focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-2 transition-colors">
              <span className="inline-flex items-center gap-2">Add to Pickup Bag <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i></span>
              <span className="tabular-nums">{fmt(product.price * qty)}</span>
            </button>
            <p className="text-xs text-[#77726c]">Adding to your bag doesn&apos;t send anything. Review and send one request from Visit.</p>
          </div>
        </div>
      </section>

      <section className="fold-shell py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-6" aria-label="Product details">
        <p className="md:col-span-5 fold-serif text-[22px] md:text-[28px] leading-[1.35] max-w-[34ch]">{product.description}</p>
        <dl className="md:col-span-6 md:col-start-7 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-10 content-start">
          <div className="border-t border-[rgba(23,21,21,0.14)] pt-4">
            <dt className="fold-label text-[#8A8580]">Ingredients</dt>
            <dd className="mt-4 text-[15px] leading-relaxed text-[#45403c]">{product.ingredients}</dd>
          </div>
          <div className="border-t border-[rgba(23,21,21,0.14)] pt-4">
            <dt className="fold-label text-[#8A8580]">Allergens</dt>
            <dd className="mt-4 text-[15px] leading-relaxed text-[#45403c]">{product.allergens}</dd>
            <dd className="mt-3 text-xs text-[#8A8580]">Made in a kitchen that handles nuts, sesame and dairy.</dd>
          </div>
        </dl>
      </section>
    </>
  );
}